import React from 'react';
import { LoginUpperRightLayout } from 'layout';
import { RestorePasswordError } from '@isyc-react/auth/modules/pods/login';
export const RestoreErrorScene = () => {
    return (React.createElement(LoginUpperRightLayout, null,
        React.createElement(RestorePasswordError, null)));
};
